import { Expose } from "class-transformer";
import { IsString, IsOptional } from "class-validator";

export class OfficeUser {
  @Expose()
  @IsString()
  userId!: string;
  @Expose()
  @IsString()
  @IsOptional()
  name!: string;
  @Expose()
  @IsString()
  friendlyName!: string;
}
